import React from "react";
import "./hero.css";
const Hero = () => {
    return (
        <div className="hero">
          <h5>Hi, my name is</h5>
          <h1>Jatin Kumar</h1>
          <h2>
            I build the web with innovative and user-friendly solutions.
          </h2>
          <p>
          I'm a passionate developer dedicated to creating efficient web applications. My enthusiasm for the latest technologies and all things geeky drives my work. I'm currently seeking new opportunities. Feel free to <span>Contact</span> me.
          </p>
        </div>
    );
};

export default Hero;